import { getHostOrigin } from "./utils/util";

export const urlBase = () => getHostOrigin();

export const isProduction = () => window.location.host === "accounts.cj.com";
